import Component from '@Component';

export default class inViewStyle extends Component {
  static selector = '[data-style]'
  static loaderPriority = 'in-view'

  constructor(el) {
    super(el);
    this.setStyle();
  }

  setStyle() {
    window.requestAnimationFrame(() => {
      if (this.$container.hasAttribute('data-style')) {
        this.$container.style = this.$container.dataset.style;
        this.$container.removeAttribute('data-style');
      }
    });
  }
}
